import * as React from 'react';
import Typography from '@mui/material/Typography';

const TextQuantity = ({children, color = '#000000', sx, ...other}) => {
  return <Typography
  sx={{
    fontSize: "22px",
    fontWeight: 400,
    lineHeight: "22px",
    letterSpacing: "0em",
    textAlign: "left",
    paddingBottom: '4px',
    color,
    ...sx
  }}
  variant="div" component="span"
  {...other}>
    {children}
  </Typography>;
}

export default TextQuantity
